import Vue from 'vue'

export const residentServiceApplicationTypesStore = {
  state: {
    residentServiceApplicationType: {},
    residentSerivceApplicationTypes: [],
    serviceApplicationTypes: [],
    errors: [],
    paginationInfo: {}
  },
  mutations: {
    setResidentServiceApplicationType(state, residentServiceApplicationType) {
      Vue.set(state, 'residentServiceApplicationType', residentServiceApplicationType)
    },
    setResidentServiceApplicationTypes(state, residentServiceApplicationTypes) {
      Vue.set(state, 'residentServiceApplicationTypes', residentServiceApplicationTypes)
    },
    setServiceApplicationTypes(state, serviceApplicationTypes) {
      Vue.set(state, 'serviceApplicationTypes', serviceApplicationTypes)
    },
    setErrors(state, errors) {
      Vue.set(state, 'errors', errors)
    },
    setPaginationInfo(state, paginationInfo) {
      Vue.set(state, 'paginationInfo', paginationInfo)
    }
  },
  actions: {
    setErrors({ commit }, errors) {
      commit('setErrors', errors)
    },
    clearResidentServiceApplicationType({ commit }) {
      commit('setResidentServiceApplicationType', {})
    },
    clearResidentServiceApplicationTypes({ commit }) {
      commit('setResidentServiceApplicationTypes', [])
    },
    clearServiceApplicationTypes({ commit }) {
      commit('setServiceApplicationTypes', {})
    },
    clearErrors({ commit }, errors) {
      commit("setErrors", [])
    },
    getResidentServiceApplicationTypes({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/resident_service_application_types`, { params }).then(data => {
          if (data.ok) {
            commit('setResidentServiceApplicationTypes', data.body.resident_service_application_types)
            commit('setPaginationInfo', data.body.pagination_info)
          }
        })
      })
    },
    createResidentServiceApplicationType({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.post(`api/v1/resident_service_application_types`, params).then(data => {
          if (data.ok) {
            resolve(data)
          }
        })
      })
    },
    deleteResidentServiceApplicationType({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/resident_service_application_types/${params.id}`).then(data => {
          resolve(data)
        })
      })
    },
    getDataForNewAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.http.get(`api/v1/resident_service_application_types/new`).then(data => {
          commit('setServiceApplicationTypes', data.body.service_application_types)
        })
      })
    }
  }
}
